import { Navigate, Route, Routes } from 'react-router-dom';
import { MainLayout } from '@/components/layout/MainLayout';
import { MenuPage } from '@/pages/MenuPage';
import { StoryPage } from '@/pages/StoryPage';
import { MapPage } from '@/pages/MapPage';
import { SkillsPage } from '@/pages/SkillsPage';
import { LogPage } from '@/pages/LogPage';
import { SpellsPage } from '@/pages/SpellsPage';
import { CharacterPage } from '@/pages/CharacterPage';
import { FactionsPage } from '@/pages/FactionsPage';
import { NotFoundPage } from '@/pages/NotFoundPage';

export function AppRouter() {
  return (
    <Routes>
      <Route path="/" element={<Navigate to="/menu" replace />} />
      <Route path="/menu" element={<MenuPage />} />
      <Route element={<MainLayout />}>
        <Route path="/game/story" element={<StoryPage />} />
        <Route path="/game/map" element={<MapPage />} />
        <Route path="/game/skills" element={<SkillsPage />} />
        <Route path="/game/log" element={<LogPage />} />
        <Route path="/game/spells" element={<SpellsPage />} />
        <Route path="/game/character" element={<CharacterPage />} />
        <Route path="/game/factions" element={<FactionsPage />} />
      </Route>
      <Route path="*" element={<NotFoundPage />} />
    </Routes>
  );
}
